import React from 'react';
import './Mission.css';

function Mission() {
  const missions = [
    {
      icon: (
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
          <path d="M4.5 16.5c-1.5 1.26-2 5-2 5s3.74-.5 5-2c.71-.84.7-2.13-.09-2.91a2.18 2.18 0 0 0-2.91-.09z"/>
          <path d="m12 15-3-3a22 22 0 0 1 2-3.95A12.88 12.88 0 0 1 22 2c0 2.72-.78 7.5-6 11a22.35 22.35 0 0 1-4 2z"/>
          <path d="M9 12H4s.55-3.03 2-4c1.62-1.08 5 0 5 0M12 15v5s3.03-.55 4-2c1.08-1.62 0-5 0-5"/>
        </svg>
      ),
      title: 'Pediatric Surgery & Urology',
      description: 'Specialized surgical procedures for children with complex conditions affecting internal organs and urological systems, performed by expert surgeons with advanced equipment.'
    },
    {
      icon: (
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
          <path d="M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2"/>
          <path d="M9 12h6m-6 4h6"/>
        </svg>
      ),
      title: 'Comprehensive Mission Phases',
      description: 'Each two-week mission includes pre-operative evaluation, surgical procedures, and post-operative care to ensure safe recovery for every child.'
    },
    {
      icon: (
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
          <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"/>
          <circle cx="9" cy="7" r="4"/>
          <path d="M23 21v-2a4 4 0 0 0-3-3.87M16 3.13a4 4 0 0 1 0 7.75"/>
        </svg>
      ),
      title: 'Medical Education',
      description: 'Working hand-in-hand with local university hospital staff, providing teaching, training, and collaborative clinical work to strengthen local surgical capacity.'
    }
  ];

  return (
    <section id="missions" className="mission section">
      <div className="container">
        <div className="section-header">
          <span className="section-subtitle">Our Mission</span>
          <h2 className="section-title">Specialized Pediatric Surgery for Complex Cases</h2>
          <p className="section-description">
            DOC Humanitarian provides complex pediatric surgery & urology to children in Cambodia 
            who need procedures that cannot be safely performed locally. In partnership with the 
            National Pediatric Hospital in Phnom Penh, we bring specialized surgical expertise 
            and essential equipment for life-changing interventions.
          </p>
        </div>

        <div className="mission-grid">
          {missions.map((mission, index) => (
            <div key={index} className="mission-card card">
              <div className="mission-icon">
                {mission.icon}
              </div>
              <h3 className="mission-title">{mission.title}</h3>
              <p className="mission-description">{mission.description}</p>
            </div>
          ))}
        </div>

        <div className="mission-story">
          <div className="story-image">
            <img src="/images/mission-story.jpg" alt="Medical team in action" />
            <div className="story-badge">
              <span className="badge-number">20+</span>
              <span className="badge-text">Years of Impact</span>
            </div>
          </div>
          <div className="story-content">
            <h3 className="story-title">Partnership & Collaboration</h3>
            <p className="story-text">
              Our close partnership with the National Pediatric Hospital in Phnom Penh, 
              Cambodia, is the foundation of our work. Local medical teams evaluate children 
              throughout the year, identifying complex cases that require our specialized 
              surgical expertise and equipment.
            </p>
            <p className="story-text">
              Each mission typically lasts two weeks and serves 40-50 children. We don't 
              just perform surgeries—we work alongside local physicians, residents, and 
              faculty in a university hospital setting, providing education and training 
              that builds lasting surgical capacity in the communities we serve.
            </p>
            <div className="story-features">
              <div className="feature-item">
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                  <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"/>
                  <polyline points="22 4 12 14.01 9 11.01"/>
                </svg>
                <span>Founded in France (2004-2005)</span>
              </div>
              <div className="feature-item">
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                  <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"/>
                  <polyline points="22 4 12 14.01 9 11.01"/>
                </svg>
                <span>Registered 501(c)(3) Non-Profit (US)</span>
              </div>
              <div className="feature-item">
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                  <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"/>
                  <polyline points="22 4 12 14.01 9 11.01"/>
                </svg>
                <span>University Hospital Partnership</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default Mission;

